module.exports = __webpack_public_path__ + "fonts/Times New Roman Bold.bed7bbf5.ttf";